import { render, staticRenderFns } from "./u-table.vue?vue&type=template&id=01018cfe&scoped=true&"
import script from "./u-table.vue?vue&type=script&lang=js&"
export * from "./u-table.vue?vue&type=script&lang=js&"
import style0 from "./u-table.vue?vue&type=style&index=0&id=01018cfe&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "01018cfe",
  null
  
)

export default component.exports